import { throttle } from 'lodash';

export function scrollHeader() {
  const headerEle = document.getElementById('header');
  const IS_HIDE = 'is-hide';

  window.addEventListener(
    'scroll',
    _.throttle(
      (e) => {
        scrollBtnView();
        return false;
      },
      100,
      { trailing: true, leading: true }
    )
  );

  // ページ読み込み時にスクロールトップボタンがkvより下にあれば表示
  window.addEventListener('load', () => {
    const scroll = window.scrollY;
    if (scroll > 200) {
      headerEle.classList.add(IS_HIDE);
    } else {
      headerEle.classList.remove(IS_HIDE);
    }
  });

  // 間引きしたい処理
  function scrollBtnView() {
    const scroll = window.scrollY;

    // スクロール量がkvの高さを超えたらページトップボタンを表示
    if (scroll > 200) {
      headerEle.classList.add(IS_HIDE);
    } else {
      headerEle.classList.remove(IS_HIDE);
    }
  }
}
